import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=084ff451&scoped=true&"
import script from "./Lang.vue?vue&type=script&lang=ts&"
export * from "./Lang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ff451",
  null
  
)

export default component.exports